import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FaqAccordion({ faqs }) {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <div className="bg-white border border-gray-100 rounded-2xl divide-y divide-gray-100">
            {faqs.map((faq, i) => {
                const isOpen = openIndex === i;
                return (
                    <div key={faq.question}>
                        <button
                            type="button"
                            onClick={() => setOpenIndex(isOpen ? -1 : i)}
                            className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left"
                        >
                            <span className="font-semibold text-gray-900 text-sm">{faq.question}</span>
                            <ChevronDown
                                className={`w-4 h-4 text-gray-400 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""
                                    }`}
                            />
                        </button>
                        {isOpen && (
                            <div className="px-6 pb-4 text-sm text-gray-600 leading-relaxed">
                                {faq.answer}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}